import { EnrichedDCConfig } from '@/models/enriched-prismic-documents.ts';
import { ConfigHook } from '@/models/hooks.ts';

import { useConfigStore } from '@/stores/config-store.ts';

// Frozen empty references: referentially stable and safe from accidental mutation
const EMPTY_CONFIGS: readonly EnrichedDCConfig[] = Object.freeze([]);
const EMPTY_CONFIG_MAP: ReadonlyMap<string, EnrichedDCConfig> = Object.freeze(new Map<string, EnrichedDCConfig>());
const EMPTY_CONFIG_RECORD: Readonly<Record<string, EnrichedDCConfig>> = Object.freeze({});
const EMPTY_INSTANCE_IDS: readonly string[] = Object.freeze([]);

export const useConfig = (): ConfigHook => {
    const { selectedLocation, selectedCustomer } = useConfigStore();

    const getInstanceConfig = (instanceId: string): EnrichedDCConfig | undefined => {
        const config = selectedLocation?.config_record[instanceId];
        return config;
    };

    const configs = selectedLocation?.configs ?? EMPTY_CONFIGS;
    const configMap = selectedLocation?.config_map ?? EMPTY_CONFIG_MAP;
    const configRecord = selectedLocation?.config_record ?? EMPTY_CONFIG_RECORD;
    const instanceIds = selectedLocation?.instance_ids ?? EMPTY_INSTANCE_IDS;
    const locationKey = selectedLocation?.key ?? '';

    return {
        customerId: selectedCustomer?.customer_id ?? '',
        selectedLocation: selectedLocation,
        selectedCustomer: selectedCustomer,
        configs: configs,
        configMap: configMap,
        configRecord: configRecord,
        instanceIds: instanceIds,
        locationKey: locationKey,
        getInstanceConfig: getInstanceConfig,
    };
};
